"use client";
import type { ReactElement } from "react";
import { cn } from "@/lib/cn";
import { formatDuration } from "@/lib/timezones";

type Props = {
  options: number[];
  selected: number;
  onChange: (value: number) => void;
};

export function DurationPills({ options, selected, onChange }: Props): ReactElement {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((minutes) => (
        <button
          key={minutes}
          onClick={() => onChange(minutes)}
          className={cn(
            "rounded-full border px-4 py-1.5 text-sm font-medium transition-colors",
            selected === minutes
              ? "border-[#029391] bg-[#029391] text-white"
              : "border-neutral-200 bg-white text-neutral-600 hover:border-[#029391] hover:text-[#029391]"
          )}
        >
          {formatDuration(minutes)}
        </button>
      ))}
    </div>
  );
}
